import { Box, Typography } from '@mui/material';
import { FC } from 'react';
import { useStyles } from '../../../theme/styles.helpers';
import { RequestModalStyles } from './RequestModal.Styles';

interface RequestModalProductProps {
  productName: string;
  isSubscription: boolean;
  indication?: string;
}

export const RequestModalProduct: FC<RequestModalProductProps> = ({ productName, isSubscription, indication }) => {
  const styles = useStyles(RequestModalStyles, {});

  return (
    <Box sx={styles.card}>
      <Typography sx={styles.cardLabel}>Angefragtes Produkt</Typography>
      <Box display="flex" alignItems="center" gap={1} flexWrap="wrap">
        <Box sx={styles.productBadge}>💊 {productName}</Box>
        {isSubscription && <Box sx={styles.subscriptionBadge}>🔁 Abonnement</Box>}
      </Box>
      {indication && (
        <Typography sx={styles.indicationText}>
          Indikation: <strong>{indication}</strong>
        </Typography>
      )}
    </Box>
  );
};
